import React from 'react';
var cursorPointer = {
  style: {
    cursor: 'pointer'
  }
};

var NoScrollbarStyle = function NoScrollbarStyle() {
  return /*#__PURE__*/React.createElement("style", null, "\n            ::-webkit-scrollbar {\n              display: none;\n            }\n            -ms-overflow-style: none;\n            scrollbar-width: none;\n          ");
};

var ScrollbarStyle = function ScrollbarStyle() {
  return /*#__PURE__*/React.createElement("style", null, "\n        ::-webkit-scrollbar {\n          display: block !important;\n          width: 5px;\n          background-color: #fff;\n        }\n        ::-webkit-scrollbar-thumb {\n          border-radius: 10px;\n          -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);\n          background-color: #ccc;\n        }\n        ::-webkit-scrollbar-track {\n          border-radius: 10px;\n          background-color: #fff;\n        }\n      ");
};

export { cursorPointer, NoScrollbarStyle, ScrollbarStyle };